export default [
  {
    text: 'Submitted',
    value: 'Submitted',
  },
  {
    text: 'Issued',
    value: 'Issued',
  },
  {
    text: 'Plan Transfer',
    value: 'Transferred',
  },
  {
    text: 'Transfer (w Pts)',
    value: 'Transfer w Pts',
  },
  {
    text: 'Withdrawn',
    value: 'Withdrawn',
  },
  {
    text: 'Cancelled',
    value: 'Cancelled',
  },
  {
    text: 'Declined',
    value: 'Declined',
  },
]
